import { render, staticRenderFns } from "./AdManSpace.vue?vue&type=template&id=1906c6b5&scoped=true"
import script from "./AdManSpace.vue?vue&type=script&lang=js"
export * from "./AdManSpace.vue?vue&type=script&lang=js"
import style0 from "./AdManSpace.vue?vue&type=style&index=0&id=1906c6b5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1906c6b5",
  null
  
)

export default component.exports